import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    RoomosFormState,
    RoomosLoadState,
    RoomosHeader,
    RoomosHeaderDefault,
    RoomosHeaderDelete,
} from "userful-chronos-app-common-js/dist/models/spaces/roomos";
import {
    requestRoomosListConfig,
    requestAddRoomosServer,
    requestRemoveRoomosServer,
    requestUpdateRoomosServer,
} from "./msgs/roomos/roomosMsgSender";

const initialState: {
    roomosServers: RoomosHeader[];
    loadState: RoomosLoadState;
    roomos: RoomosHeader;
    copyRoomos: RoomosHeader;
    formType: RoomosFormState;
    openForm: boolean;
} = {
    roomosServers: [],
    loadState: "RENDER",
    roomos: RoomosHeaderDefault(),
    copyRoomos: RoomosHeaderDefault(),
    formType: "Create",
    openForm: false,
};

export const roomosSlice = createSlice({
    name: "roomosSlice",
    initialState,
    reducers: {
        getRoomosDevicesFromServer: (state, action: PayloadAction<{}>) => {
            requestRoomosListConfig();
        },
        updateServerToServer: (state, action: PayloadAction<RoomosHeader>) => {
            requestAddRoomosServer(action.payload);
        },
        requestRemoveServer: (state, action: PayloadAction<string>) => {
            requestRemoveRoomosServer(action.payload);
        },
        requestUpdateServer: (state, action: PayloadAction<RoomosHeader>) => {
            requestUpdateRoomosServer(action.payload);
        },
        setSpacesServersConfig: (state, action: PayloadAction<RoomosHeader[]>) => {
            state.roomosServers = action.payload;
        },
        setSpacesConfig: (state, action: PayloadAction<RoomosHeader>) => {
            state.roomos = action.payload;
        },
        setCopySpacesConfig: (state, action: PayloadAction<RoomosHeader>) => {
            state.copyRoomos = action.payload;
        },
        changeLoadState: (state, action: PayloadAction<RoomosLoadState>) => {
            state.loadState = action.payload;
        },
        setFormType: (state, action: PayloadAction<RoomosFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
    },
});

export const roomosActions = roomosSlice.actions;

export default roomosSlice.reducer;
